import { FlexBox, IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';

import { ApiToken } from 'apis/auth';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import { useCopy } from 'utils/useCopy';

import { pathToApiTokensSettings } from '../../settingsIntegrationsApiTokens.view';

type ApiTokensTableActionsProps = {
  id: string;
  name: string;
  token: string;
  handleDeleteApiToken: (props: Pick<ApiToken, 'id' | 'name'>) => void;
};

export const ApiTokensTableActions = ({
  id,
  name,
  token,
  handleDeleteApiToken,
}: ApiTokensTableActionsProps): JSX.Element => {
  const navigate = useAppNavigate();

  const [copyToClipboard, copyState] = useCopy();

  return (
    <FlexBox flexDirection="row">
      <Tooltip content="View token" dark>
        <IconButton
          variant="tertiary"
          icon="eye"
          onClick={() => {
            ampli.settingsIntegrationsApiTokensView();

            navigate({
              path: `${pathToApiTokensSettings}/:id`,
              params: {
                path: {
                  id,
                },
              },
            });
          }}
        />
      </Tooltip>

      <Tooltip
        content={copyState.status === 'copied' ? 'Copied' : 'Copy token'}
        dark
      >
        <IconButton
          variant="tertiary"
          icon={copyState.status === 'copied' ? 'done' : 'copy'}
          onClick={() => {
            copyToClipboard(token);
            ampli.settingsIntegrationsApiTokensCopy();
          }}
        />
      </Tooltip>

      <Tooltip content="Delete" dark>
        <IconButton
          variant="tertiary"
          icon="trash"
          onClick={() =>
            handleDeleteApiToken({
              id,
              name,
            })
          }
        />
      </Tooltip>
    </FlexBox>
  );
};
